import { AUTH_TYPES } from '@/constants/route-names'
import { isEmailInvalid, isPasswordInvalid } from '@/helpers/validation'
import Input from '@/components/Form/Input.vue'
import InputPassword from '@/components/Form/InputPassword.vue'

const AUTH_TYPE_KEYS = Object.keys(AUTH_TYPES)
const AUTH_INDEXES = {}
AUTH_TYPE_KEYS.forEach((k, i) => (AUTH_INDEXES[k] = i))
export { AUTH_INDEXES }

export const SLIDE_LENGTH = AUTH_TYPE_KEYS.length

const FIELD_KEYS = {
  email: 'email',
  password: 'password',
  passwordConfirmation: 'passwordConfirmation',
}

export function getSlideIndexFromRoute(route) {
  return AUTH_INDEXES[AUTH_TYPES[route?.params?.type] || AUTH_TYPES.login]
}

const invalidEmailsReported = []

export function getFields(formType) {
  const vm = this
  const fields = {
    [FIELD_KEYS.email]: {
      component: Input,
      props: {
        id: 'email',
        type: 'email',
        label: this.$t('labels.email'),
        isInvalid: email => {
          const isInvalid = isEmailInvalid.call(this, email)

          if (isInvalid && !invalidEmailsReported.includes(email)) {
            this.$sentry.withScope(scope => {
              scope.setExtras({ email, formType })
              this.$sentry.captureMessage('[Auth form] - Provided email is invalid.')
            })
            invalidEmailsReported.push(email)
          }
          return isInvalid
        },
        autocomplete: 'email',
        autocorrect: 'off',
        autocapitalize: 'none',
      },
    },
    [FIELD_KEYS.password]: {
      component: InputPassword,
      props: {
        id: 'password',
        type: 'password',
        label: this.$t('labels.password'),
        isInvalid:
          formType === AUTH_TYPES.signup || formType === AUTH_TYPES.resetPassword
            ? value => isPasswordInvalid.call(this, value)
            : null,
        autocomplete: formType === AUTH_TYPES.login ? 'current-password' : 'new-password',
      },
      validateAlso: 'passwordConfirmation',
    },
    [FIELD_KEYS.passwordConfirmation]: {
      component: InputPassword,
      props: {
        id: 'passwordConfirmation',
        type: 'password',
        label: this.$t('labels.passwordConfirmation'),
        isInvalid(value) {
          return value !== vm.formData[formType].password
            ? this.$t('errors.invalidPasswordConfirmation')
            : false
        },
        autocomplete: 'new-password',
      },
    },
  }
  const fieldMap = {
    [AUTH_TYPES.login]: [FIELD_KEYS.email, FIELD_KEYS.password],
    [AUTH_TYPES.signup]: [FIELD_KEYS.email, FIELD_KEYS.password, FIELD_KEYS.passwordConfirmation],
    [AUTH_TYPES.passwordForgotten]: [FIELD_KEYS.email],
    [AUTH_TYPES.resetPassword]: [FIELD_KEYS.password, FIELD_KEYS.passwordConfirmation],
  }
  return fieldMap[formType].map(key => fields[key])
}
